import type { Pick } from '@prisma/client/runtime/library';
import type { OptionListProps } from '@shopify/polaris';

export type ISettingOption = NonNullable<OptionListProps['options']>[number];
export type ISettingOptions = ISettingOption[];

export enum PreferenceType {
  PLAN_INFORMATION = 'plan_information',
  USAGE_BILLING = 'usage_billing',
  BILLING_SUMMARY = 'billing_summary',
  PROFILE_SETTINGS = 'profile_settings',
  STORE_SETTINGS = 'store_settings',
  CUSTOM_CODE = 'custom_code',
  TEMPLATES_BY_GEMX = 'templates_by_gemx',
  LANGUAGE_SETTINGS = 'language_settings',
  DANGER_ZONE = 'danger_zone',
}
export interface IComponentPreference extends Pick<ISettingOption, 'label' | 'media'> {
  type: PreferenceType;
  component: React.FC;
  subComponent?: React.FC;
  show: boolean;
}
export type IComponentPreferences = IComponentPreference[];
